import { Intent, Tag } from "@blueprintjs/core";
import styled from "@emotion/styled";
import { Link } from "react-router";

import { Box, Flex } from "@/components/layout/flexbox";
import { ChatComponent } from "@/components/pieces/chat/ChatComponent";
import { Avatar } from "@/components/pieces/users/Avatar";
import { CARD_CLASSES } from "@/css/constants";
import { FullReviewQuery } from "@/graphql";
import { MeetingCoach } from "@/types/coaches";
import { FullMeetingUser, FullReviewUser } from "@/types/users";

type ReviewCoach = NonNullable<NonNullable<FullReviewQuery["review"]>["coach"]>;

type Coach = (ReviewCoach | MeetingCoach) & {
  coachSlug?: string | null;
};

interface ServiceChatProps {
  isCoach: boolean;
  customer?: FullReviewUser | FullMeetingUser | null;
  coach?: Coach | null;
  chatChannelId: string;
}

export function ServiceChat({
  isCoach,
  customer,
  coach,
  chatChannelId,
}: ServiceChatProps) {
  return (
    <Box
      width={["100%", "auto"]}
      ml={[0, 0, 0, 24]}
      backgroundColor="#FFF"
      style={{
        position: "sticky",
        top: 80,
      }}
      className={CARD_CLASSES}
    >
      <Flex p={3} className="bbs" alignItems="center">
        {isCoach && customer ? (
          <>
            <Avatar user={customer} size={60} />
            <Box ml={12}>
              <Flex alignItems="center">
                <Box fontSize={18} fontWeight={600}>
                  {customer.name}
                </Box>
                <Box ml={2}>
                  <Tag intent={Intent.PRIMARY} minimal={true} round>
                    Client
                  </Tag>
                </Box>
              </Flex>
              <Box fontSize={14} alignItems="center">
                <Link to={`/client/${customer.id}`}>View Profile</Link>
              </Box>
            </Box>
          </>
        ) : (
          <>
            <Avatar user={coach} size={60} />
            <Box ml={12}>
              <Box fontSize={18} fontWeight={600}>
                {coach?.name}
              </Box>
              <Box fontSize={14}>
                <Link to={`/@${coach?.coachSlug}`}>See full profile</Link>
              </Box>
            </Box>
          </>
        )}
      </Flex>
      <Box fontWeight={500} p={3}>
        Chat With {isCoach ? "Client" : "Coach"}
      </Box>
      <ChatStyles>
        <ChatComponent
          height={500}
          channelId={chatChannelId}
          customerId={customer?.id}
          frozenMessage="Messaging no longer available"
        />
      </ChatStyles>
    </Box>
  );
}

const ChatStyles = styled("div")`
  .messaging.str-chat .str-chat__list {
    background-color: #fff !important;

    .str-chat__message-team:hover {
      background-color: #fbfbff;
    }
  }
`;
